import { Container } from "@mui/material";
import React from "react";
import { SectionHeading, SectionWrapper } from "../../../styles";
import Accordion from "../../../components/AccordianForfaqs";

const index = () => {
  return (
    <div id="faq">
      <SectionWrapper p="4rem 0">
        <Container maxWidth="xl">
          <SectionHeading align="center">FAQs</SectionHeading>
          <Accordion />
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
